export default function ProfileDropIcon({children}) {
  return (
    <div className="profile-dropdown-icon">
      <div className="profile-dropdown-main-icon">
        {children}
      </div>
    </div>
  );
}
